import { createSelector } from 'reselect';
import { CurrentCouponRedemptionCodeIdentifierSelector } from './coupon.redemption.code.selectors';
import { getSearchFieldsTemplate } from '../../components/search/search.constants';
export var CouponSearchRecordCountSelector = createSelector([CurrentCouponRedemptionCodeIdentifierSelector], function (couponRedemptionCodeId) {
  return couponRedemptionCodeId ? 1 : -1;
});
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.searchCoupons.couponSearchModel;
};
export var CouponSearchModelSelector = createSelector([recoverableUIStateSelector], function (state) {
  return state ? state : getSearchFieldsTemplate();
});